import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { useIntl } from "react-intl"

// Services
import { getProducts } from "../../../services/productService"
import { addPayment } from "../../../services/auth"

// Components
import { toast } from "react-toastify"
import { ChoosePricingSection, Features, Spinner } from "../../common"
import { Hero } from "./components"

// Redux
import {
  setClientSecret,
  setInvoiceId,
  setProduct,
  setQuantity,
  setSetupIntentId,
} from "../../../redux/slices/signupSlice"

// Constants
import { PLAN_TYPES, TALK_TO_US_URL } from "../../../constants"

const ChoosePricingPage = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()

  const [loading, setLoading] = useState(false);
  const [planType, setPlanType] = useState(PLAN_TYPES.PREMIUM);
  const [productsLoading, setProductsLoading] = useState(true)
  const [products, setProducts] = useState({ oneTime: [], subscription: [] })

  const enterpriseTabSelected = planType === PLAN_TYPES.ENTERPRISE;

  const handleSelectedProductChange = (product, quantity) => {
    dispatch(setProduct(product))
    dispatch(setQuantity(quantity))
  }

  const handleContinue = async (quantity = 1) => {
    if (enterpriseTabSelected) {
      return window.open(TALK_TO_US_URL, "_blank");
    }

    // TODO: implement a better way of selecting the product
    const selectedProduct = products.at(0);

    if (!selectedProduct) {
      toast.error(formatMessage({ id: "toast.somethingWentWrong" }));
      console.error("Selected product not found");
      return;
    }

    handleSelectedProductChange(selectedProduct, quantity);

    // Handle Payment thing
    setLoading(true);

    try {
      const data = await addPayment({
        productId: selectedProduct.id,
        productQuantity: quantity,
      })

      dispatch(setClientSecret(data.clientSecret))
      dispatch(setSetupIntentId(data.setupIntentId || null))
      dispatch(setInvoiceId(data.invoiceId || null))

      // TODO: Check why this timeout is needed
      setTimeout(() => {
        navigate("/payment")
      }, 100)
    } catch (err) {
      toast.error(formatMessage({ id: "toast.somethingWentWrong" }))
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const fetchProducts = async () => {
      setProductsLoading(true)
      getProducts()
        .then((data) => {
          const allProducts = [...data.products]
          setProducts(allProducts)
        })
        .catch((_error) => {
          toast.error(formatMessage({ id: "toast.somethingWentWrong" }));
        })
        .finally(() => {
          setProductsLoading(false)
        })
    }

    fetchProducts()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Only show this page to Freemium users
  // if (auth.isAuthenticated && auth.onboardingStage !== "Trialing") {
  //   return <Navigate to={"/job-match/select-cv"} />
  // }

  // if (auth.onboardingStage !== "ChoosePrice") {
  //   return <Navigate to={"/"} />
  // }

  if (productsLoading) {
    return (
      <div className="choose-pricing">
        <div className="choose-pricing__loader">
          <Spinner />
        </div>
      </div>
    )
  }

  return (
    <>
      <div className="choose-pricing">
        <Hero
          planType={planType}
          setPlanType={setPlanType}
        />

        <ChoosePricingSection
          planType={planType}
          handleContinueClick={handleContinue}
          loading={loading}
          topOffset={-200}
        />

        <Features />
      </div>
    </>
  )
}

export default ChoosePricingPage
